import ShirtLoader from './shirt-loader';

export default ShirtLoader;
export { ShirtLoader };